export const ClimateRegion = [
  { label: 'Alaska', value: 584 },
  { label: 'Alabama', value: 2803 },
  { label: 'Arizona', value: 583 },
  { label: 'Arkansas', value: 129 },
  { label: 'California', value: 1986 },
  { label: 'Colorado', value: 582 },
  { label: 'Connecticut', value: 935 },
  { label: 'District of Columbia', value: 1402 },
  { label: 'Delaware', value: 1401 },
  { label: 'Florida', value: 2804 },
  { label: 'Georgia', value: 2805 },
  { label: 'Hawaii', value: 2806 },
  { label: 'Iowa', value: 1400 },
  { label: 'Idaho', value: 581 },
  { label: 'Illinois', value: 936 },
  { label: 'Indiana', value: 937 },
  { label: 'Kansas', value: 1403 },
  { label: 'Kentucky', value: 1404 },
  { label: 'Louisiana', value: 2807 },
  { label: 'Massachusetts', value: 938 },
  { label: 'Maryland', value: 1405 },
  { label: 'Maine', value: 580 },
  { label: 'Michigan', value: 939 },
  { label: 'Minnesota', value: 934 },
  { label: 'Missouri', value: 1406 },
  { label: 'Mississippi', value: 585 },
  { label: 'Montana', value: 586 },
  { label: 'North Carolina', value: 1987 },
  { label: 'North Dakota', value: 587 },
  { label: 'Nebraska', value: 933 },
  { label: 'New Hampshire', value: 588 },
  { label: 'New Jersey', value: 1407 },
  { label: 'New Mexico', value: 932 },
  { label: 'Nevada', value: 931 },
  { label: 'New York', value: 589 },
  { label: 'Ohio', value: 930 },
  { label: 'Oklahoma', value: 2808 },
  { label: 'Oregon', value: 929 },
  { label: 'Pennsylvania', value: 928 },
  { label: 'Rhode Island', value: 590 },
  { label: 'South Carolina', value: 1988 },
  { label: 'South Dakota', value: 579 },
  { label: 'Tennessee', value: 1989 },
  { label: 'Texas', value: 2809 },
  { label: 'Utah', value: 940 },
  { label: 'Virginia', value: 1408 },
  { label: 'Vermont', value: 578 },
  { label: 'Washington', value: 941 },
  { label: 'Wisconsin', value: 577 },
  { label: 'West Virginia', value: 1409 },
  { label: 'Wyoming', value: 576 },
];

export const AvgElectricityRate = {
  Alaska: 21.32,
  Alabama: 12.38,
  Arkansas: 9.42,
  Arizona: 11.7,
  California: 21.43,
  Colorado: 12.14,
  Connecticut: 21.29,
  'District of Columbia': 12.26,
  Delaware: 11.77,
  Florida: 11.65,
  Georgia: 10.94,
  Hawaii: 30.55,
  Iowa: 10.87,
  Idaho: 10.05,
  Illinois: 12.3,
  Indiana: 12.25,
  Kansas: 11.87,
  Kentucky: 10.46,
  Louisiana: 9.58,
  Massachusetts: 22.32,
  Maryland: 12.61,
  Maine: 16.5,
  Michigan: 16.92,
  Minnesota: 12.48,
  Missouri: 9.38,
  Mississippi: 10.88,
  Montana: 10.72,
  'North Carolina': 10.6,
  'North Dakota': 9.44,
  Nebraska: 9.41,
  'New Hampshire': 18.93,
  'New Jersey': 16.18,
  'New Mexico': 12.53,
  Nevada: 11.53,
  'New York': 18.27,
  Ohio: 11.83,
  Oklahoma: 8.92,
  Oregon: 11.01,
  Pennsylvania: 13.09,
  'Rhode Island': 23.41,
  'South Carolina': 11.99,
  'South Dakota': 10.99,
  Tennessee: 10.36,
  Texas: 11.39,
  Utah: 10.04,
  Virginia: 11.05,
  Vermont: 18.38,
  Washington: 9.76,
  Wisconsin: 14.05,
  'West Virginia': 11.2,
  Wyoming: 10.47,
};

export const AvgGasRate = {
  Alabama: 16.01,
  Alaska: 11.14,
  Arizona: 13.1,
  Arkansas: 12.28,
  California: 14.14,
  Colorado: 7.22,
  Connecticut: 14.68,
  Delaware: 12.95,
  'District of Columbia': 11.92,
  Florida: 21.38,
  Georgia: 15.45,
  Hawaii: 37.75,
  Idaho: 6.73,
  Illinois: 7.94,
  Indiana: 8.59,
  Iowa: 7.78,
  Kansas: 9.37,
  Kentucky: 11.14,
  Louisiana: 12.15,
  Maine: 14.88,
  Maryland: 13.07,
  Massachusetts: 14.71,
  Michigan: 8.25,
  Minnesota: 8.04,
  Mississippi: 11.51,
  Missouri: 10.39,
  Montana: 7.22,
  Nebraska: 8.04,
  Nevada: 10.36,
  'New Hampshire': 14.66,
  'New Jersey': 9.92,
  'New Mexico': 7.04,
  'New York': 12.8,
  'North Carolina': 13.23,
  'North Dakota': 6.82,
  Ohio: 9.53,
  Oklahoma: 9.11,
  Oregon: 10.91,
  Pennsylvania: 11.48,
  'Rhode Island': 15.06,
  'South Carolina': 13.49,
  'South Dakota': 7.11,
  Tennessee: 8.97,
  Texas: 11.64,
  Utah: 8.15,
  Vermont: 13.21,
  Virginia: 12.72,
  Washington: 10.97,
  'West Virginia': 10.11,
  Wisconsin: 7.52,
  Wyoming: 8.84,
};

export const CapacityRange = [
  {
    label: '9,000 BTU',
    value: 9000,
  },
  {
    label: '12,000 BTU',
    value: 12000,
  },
  {
    label: '18,000 BTU',
    value: 18000,
  },
  {
    label: '24,000 BTU',
    value: 24000,
  },
  {
    label: '30,000 BTU',
    value: 30000,
  },
  {
    label: '36,000 BTU',
    value: 36000,
  },
  {
    label: '48,000 BTU',
    value: 48000,
  },
];

export const AFUEValues = [...Array(91).keys()]
  .map((i) => i + 10)
  .map((i) => ({ value: i, label: `${i} AFUE` }));

export const SEERValues = [...Array(16).keys()]
  .map((i) => i + 10)
  .map((i) => ({ value: i, label: `${i} SEER` }));
